// @flow
import path from 'ramda/es/path';

import shopApiRequest from 'app/actions/shopApi';
import action from 'app/common/lib/action';


export const SHOP_DELIVERY_POINTS_REQUEST = 'SHOP_DELIVERY_POINTS_REQUEST';
export const SHOP_DELIVERY_POINTS_SUCCESS = 'SHOP_DELIVERY_POINTS_SUCCESS';
export const SHOP_DELIVERY_POINTS_FAILURE = 'SHOP_DELIVERY_POINTS_FAILURE';
export const SHOP_DELIVERY_POINTS_CLEAR = 'SHOP_DELIVERY_POINTS_CLEAR';
export const SHOP_DELIVERY_POINTS_CURRENT = 'SHOP_DELIVERY_POINTS_CURRENT';


/**
 * Запрос точек доставки
 */
export const deliveryPointsFetch = (shippingId: number) => async (dispatch: Function) => {
  dispatch(action(SHOP_DELIVERY_POINTS_REQUEST));
  try {
    const res = await shopApiRequest(`shipping_methods/${shippingId}/delivery_points`, 'get');
    const data = path(['data', 'data'], res) || [];
    // const currentDeliveryPointId = path([0, 'id'], data) || null;
    // убираем отсюда начальную инициализацию точки доставки, так как она может отфильтроваться позже
    dispatch(action(SHOP_DELIVERY_POINTS_SUCCESS, { data }));
    return true;
  } catch (error) {
    dispatch(action(SHOP_DELIVERY_POINTS_FAILURE, {
      err: 'Запрос точек доставки не удался',
      error,
    }));
    return false;
  }
};
